module.exports = __webpack_public_path__ + "static/media/QI.6cb47d7a.png";